(() => {
  const MAIN_PREFIX = 'product-image-swiper-';
  const DETAIL_PREFIX = 'detail-card-swiper-';
  const SELECTOR = '.swiper[class*="' + MAIN_PREFIX + '"], .swiper[class*="' + DETAIL_PREFIX + '"]';

  const idFrom = (el, prefix) => {
    for (const name of el.classList) {
      if (name.indexOf(prefix) !== 0) continue;
      const id = name.slice(prefix.length);
      if (id && id.indexOf('pagination') !== 0) return id;
    }
    return null;
  };

  const build = (el) => {
    if (el.swiper) return;

    const mainId = idFrom(el, MAIN_PREFIX);
    const detailId = mainId ? null : idFrom(el, DETAIL_PREFIX);
    if (!mainId && !detailId) return;

    const pagination = mainId
      ? '.' + MAIN_PREFIX + 'pagination-' + mainId
      : '.' + DETAIL_PREFIX + 'pagination-' + detailId;

    try {
      new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        pagination: {
          el: pagination,
          clickable: true,
          bulletClass: 'swiper-pagination-bullet',
          bulletActiveClass: 'swiper-pagination-bullet-active',
        },
        lazy: { loadPrevNext: true },
        observer: true,
        observeParents: true,
        speed: 300,
      });
    } catch (error) {
      console.warn('[card-swiper] init failed', el, error);
    }
  };

  const supportsObserver = 'IntersectionObserver' in window;
  const observer = supportsObserver
    ? new IntersectionObserver(
        (entries, self) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            self.unobserve(entry.target);
            build(entry.target);
          }
        },
        { rootMargin: '600px 0px' }
      )
    : null;

  const seen = new WeakSet();

  const collect = () => {
    if (typeof Swiper === 'undefined') {
      setTimeout(collect, 100);
      return;
    }
    document.querySelectorAll(SELECTOR).forEach((el) => {
      if (seen.has(el)) return;
      seen.add(el);
      if (observer) observer.observe(el);
      else build(el);
    });
  };

  const start = () => {
    collect();

    let timer = null;
    new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(collect, 300);
    }).observe(document.body, { childList: true, subtree: true });

    document.addEventListener('click', (event) => {
      const gallery = event.target.closest('.product-card-swiper-gallery');
      if (!gallery) return;
      if (event.target.closest('.swiper-pagination')) return;

      const url = gallery.getAttribute('data-product-url');
      if (!url) return;

      if (event.metaKey || event.ctrlKey || event.shiftKey) {
        event.preventDefault();
        window.open(url, '_blank');
      } else {
        window.location.href = url;
      }
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
